import type { Method } from 'axios';
import Axios from 'axios';

import config from '../config';
import { isPublicRoute } from '../utils/api';

export const oktaReactQueryAxiosInstance = Axios.create({
  baseURL: config.API_URL,
  timeout: config.NETWORK_REQUEST_TIMEOUT_IN_MILLIS,
  headers: {
    'Content-Type': 'application/json',

    appVersion: process.env.VITE_VERSION,
  },
});

export const jwtReactQueryAxiosInstance = Axios.create({
  baseURL: config.API_URL,
  timeout: config.NETWORK_REQUEST_TIMEOUT_IN_MILLIS,
  headers: {
    'Content-Type': 'application/json',
    appVersion: process.env.VITE_VERSION,
  },
});

export const getReactQueryAxiosInstance = () => {
  if (isPublicRoute()) {
    return jwtReactQueryAxiosInstance;
  }
  return oktaReactQueryAxiosInstance;
};

export const makeAPIRequestReactQuery = async <Data>(
  url = '',
  params: any = {},
  method: Method = 'GET',
  opts?: Parameters<typeof oktaReactQueryAxiosInstance.request<Data>>[0],
): Promise<Data> => {
  const instance = getReactQueryAxiosInstance();

  const request = await instance.request<Data>({
    method,
    url,
    params,
    ...opts,
  });
  return request.data;
};

export const makeAPIRequestReactQueryWithHeaders = async <Data>(
  url = '',
  params: any = {},
  headers: any = {},
  method: Method = 'GET',
  opts?: Parameters<typeof oktaReactQueryAxiosInstance.request<Data>>[0],
): Promise<Data> => {
  const instance = getReactQueryAxiosInstance();

  const request = await instance.request<Data>({
    method,
    url,
    params,
    headers,
    ...opts,
  });
  return request.data;
};
